/**
 * PricesSectionSkeleton - Loading skeleton for prices section
 *
 * Displays placeholder content while price data is loading.
 */
import type { ReactElement } from 'react';

export default function PricesSectionSkeleton(): ReactElement {
  return (
    <section className="px-6 pb-6">
      <div className="bg-slate/50 border-storm rounded-xl border p-5">
        {/* Section Header */}
        <div className="bg-slate mb-4 h-3 w-16 animate-pulse rounded" />

        {/* Price Grid */}
        <div className="grid grid-cols-3 gap-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="text-center">
              <div className="bg-slate mx-auto mb-1 h-3 w-12 animate-pulse rounded" />
              <div className="bg-slate mx-auto h-5 w-14 animate-pulse rounded" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
